<nav class="navbar">
  <div class="container-fluid z-1">
    <a class="navbar-brand" href="https://www.builtgenix.com">
      <img src="assets/img/logo.png" alt="Logo" />
    </a>

    <div class="nav-actions">
      <button *ngIf="isLoggedIn()" class="btn btn-icon menu-toggle align-self-center border-0" (click)="toggleMenu()">
        <i class="material-icons"
         style="font-size: 2rem; align-self: center;"
         [ngbTooltip]="'Menu'">menu</i>
        <span class="menu-badge" *ngIf="unreadMessagesCount > 0">{{unreadMessagesCount}}</span>
      </button>

      <ng-container *ngIf="isSignUp()">
        <a class="btn btn-nav" routerLink="login">Log In</a>
      </ng-container>
      <ng-container *ngIf="isLogIn()">
        <a class="btn btn-nav" routerLink="signUp">Sign Up</a>
      </ng-container>
    </div>
  </div>
  <div *ngIf="clientName" class="client-wrapper d-flex justify-content-center">
    <span>{{ clientName }}</span>
  </div>
</nav>

<app-menu [isOpen]="isMenuOpen" [user]="user" [isLoggedIn]="isLoggedIn()" (close)="closeMenu()"></app-menu>
